// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12px);
  }
}




.rcw-conversation-container > .rcw-header {
  background-color: #ecdbf4;
  background-image: "https://postimg.cc/0MQ0xw7W"; /* Replace with the path to your image */
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  
}


.rcw-title .avatar {
  width: 120px; /* Desired width */
  height: 120px; /* Desired height */
  border-radius: 50%; /* Assuming you want it circular */
  /* Add any additional styles you need */
}

 .rcw-client .rcw-message-text {
    background-color: #ecdbf4 !important;
}

.rcw-launcher {
   animation: bounce 2s infinite;
   background-color:#ecdbf4 !important;
   height:84px;
   width:84px;
   left:0 !important;
   bottom:5px !important;
   right:0px !important;
   top:1px !important;
   margin-top:12px;
}


@media screen and (max-width: 800px) {
   .rcw-launcher {
      height: 84px !important; /* Fixed height */
      width: 84px !important; /* Fixed width */
      left:0 !important;
      bottom:5px !important;
      right: 5px !important;
      top:1px !important;
      margin-left:10px;
      margin-top:12px;
      /* Add any other styles you want to apply specifically for smaller screens */
   }
}

.rcw-open-launcher {
	margin-left:-10px;
}

@media screen and (max-width: 800px) {
   .rcw-open-launcher {
      margin-left:-5px;
      margin-top:5px;
      /* Add any other styles you want to apply specifically for smaller screens */
   }
}



.quick-buttons-container .quick-list-button button {
  background-color: #ecdbf4; /* New background color */
  color: black; /* Text color for the button */
  border: none; /* Remove border if present */
  padding: 5px 10px; /* Add padding as needed */
  border-radius: 10px; /* Rounded edges for pill shape */
  cursor: pointer; /* Change mouse cursor on hover */
}

.quick-buttons-container::-webkit-scrollbar {
    display: none;
}

.quick-buttons-container {
   opacity: 0.98;
}

/* Change background color on hover */
.quick-buttons-container .quick-list-button button:hover {
  background-color: #6b2a89;
}




.rcw-conversation-container .rcw-title {
  font-weight: bold;
  color: black;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, sans-serif;
  font-size: 24px !important;
  margin: 0 !important;
  padding: 15px 0 !important;
}

.rcw-conversation-container .rcw-close-button {
  background-color:#ecdbf4 !important;
}


.rcw-messages-container{
  opacity:0.98;

}
.rcw-messages-container::-webkit-scrollbar {
    display: none;
}



.rcw-new-message::-webkit-scrollbar {
 display: none;
}


.rcw-input::-webkit-scrollbar {
  display: none;
}


/*

@media screen and (max-width: 768px) {
    .chat-widget-container {
        width: 250px;
        height: 400px;
    }
}


@media screen and (max-width: 480px) {
    .chat-widget-container {
        width: 100px;
        height: 1000px;
    }
}

*/
/*
.rcw-input {
  display: block;
  height: auto; 
  line-height: 24px; 
  max-height: 150px; 
  overflow-y: auto;
  user-select: text;
  white-space: pre-wrap;
  word-wrap: break-word;
  z-index: 999999 !important;
  &:focus-visible {
    outline: none;
  }

  &[placeholder]:empty::before {
    content: attr(placeholder);
    color: \$grey-0; 
  }
}

*/


`, "",{"version":3,"sources":["webpack://./src/lily_styles.css"],"names":[],"mappings":"AAAA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;;;;AAKA;EACE,yBAAyB;EACzB,+CAA+C,EAAE,wCAAwC;EACzF,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;;AAE1B;;;AAGA;EACE,YAAY,EAAE,kBAAkB;EAChC,aAAa,EAAE,mBAAmB;EAClC,kBAAkB,EAAE,kCAAkC;EACtD,uCAAuC;AACzC;;CAEC;IACG,oCAAoC;AACxC;;AAEA;GACG,6BAA6B;GAC7B,mCAAmC;GACnC,WAAW;GACX,UAAU;GACV,iBAAiB;GACjB,qBAAqB;GACrB,oBAAoB;GACpB,kBAAkB;GAClB,eAAe;AAClB;;;AAGA;GACG;MACG,uBAAuB,EAAE,iBAAiB;MAC1C,sBAAsB,EAAE,gBAAgB;MACxC,iBAAiB;MACjB,qBAAqB;MACrB,qBAAqB;MACrB,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,4EAA4E;GAC/E;AACH;;AAEA;CACC,iBAAiB;AAClB;;AAEA;GACG;MACG,gBAAgB;MAChB,cAAc;MACd,4EAA4E;GAC/E;AACH;;;;AAIA;EACE,yBAAyB,EAAE,yBAAyB;EACpD,YAAY,EAAE,8BAA8B;EAC5C,YAAY,EAAE,6BAA6B;EAC3C,iBAAiB,EAAE,0BAA0B;EAC7C,mBAAmB,EAAE,iCAAiC;EACtD,eAAe,EAAE,iCAAiC;AACpD;;AAEA;IACI,aAAa;AACjB;;AAEA;GACG,aAAa;AAChB;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;AAC3B;;;;;AAKA;EACE,iBAAiB;EACjB,YAAY;EACZ,0EAA0E;EAC1E,0BAA0B;EAC1B,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;;AAGA;EACE,YAAY;;AAEd;AACA;IACI,aAAa;AACjB;;;;AAIA;CACC,aAAa;AACd;;;AAGA;EACE,aAAa;AACf;;;AAGA;;;;;;;;;;;;;;;;;CAiBC;AACD;;;;;;;;;;;;;;;;;;;;;CAqBC","sourcesContent":["@keyframes bounce {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-12px);\n  }\n}\n\n\n\n\n.rcw-conversation-container > .rcw-header {\n  background-color: #ecdbf4;\n  background-image: \"https://postimg.cc/0MQ0xw7W\"; /* Replace with the path to your image */\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  \n}\n\n\n.rcw-title .avatar {\n  width: 120px; /* Desired width */\n  height: 120px; /* Desired height */\n  border-radius: 50%; /* Assuming you want it circular */\n  /* Add any additional styles you need */\n}\n\n .rcw-client .rcw-message-text {\n    background-color: #ecdbf4 !important;\n}\n\n.rcw-launcher {\n   animation: bounce 2s infinite;\n   background-color:#ecdbf4 !important;\n   height:84px;\n   width:84px;\n   left:0 !important;\n   bottom:5px !important;\n   right:0px !important;\n   top:1px !important;\n   margin-top:12px;\n}\n\n\n@media screen and (max-width: 800px) {\n   .rcw-launcher {\n      height: 84px !important; /* Fixed height */\n      width: 84px !important; /* Fixed width */\n      left:0 !important;\n      bottom:5px !important;\n      right: 5px !important;\n      top:1px !important;\n      margin-left:10px;\n      margin-top:12px;\n      /* Add any other styles you want to apply specifically for smaller screens */\n   }\n}\n\n.rcw-open-launcher {\n\tmargin-left:-10px;\n}\n\n@media screen and (max-width: 800px) {\n   .rcw-open-launcher {\n      margin-left:-5px;\n      margin-top:5px;\n      /* Add any other styles you want to apply specifically for smaller screens */\n   }\n}\n\n\n\n.quick-buttons-container .quick-list-button button {\n  background-color: #ecdbf4; /* New background color */\n  color: black; /* Text color for the button */\n  border: none; /* Remove border if present */\n  padding: 5px 10px; /* Add padding as needed */\n  border-radius: 10px; /* Rounded edges for pill shape */\n  cursor: pointer; /* Change mouse cursor on hover */\n}\n\n.quick-buttons-container::-webkit-scrollbar {\n    display: none;\n}\n\n.quick-buttons-container {\n   opacity: 0.98;\n}\n\n/* Change background color on hover */\n.quick-buttons-container .quick-list-button button:hover {\n  background-color: #6b2a89;\n}\n\n\n\n\n.rcw-conversation-container .rcw-title {\n  font-weight: bold;\n  color: black;\n  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, sans-serif;\n  font-size: 24px !important;\n  margin: 0 !important;\n  padding: 15px 0 !important;\n}\n\n.rcw-conversation-container .rcw-close-button {\n  background-color:#ecdbf4 !important;\n}\n\n\n.rcw-messages-container{\n  opacity:0.98;\n\n}\n.rcw-messages-container::-webkit-scrollbar {\n    display: none;\n}\n\n\n\n.rcw-new-message::-webkit-scrollbar {\n display: none;\n}\n\n\n.rcw-input::-webkit-scrollbar {\n  display: none;\n}\n\n\n/*\n\n@media screen and (max-width: 768px) {\n    .chat-widget-container {\n        width: 250px;\n        height: 400px;\n    }\n}\n\n\n@media screen and (max-width: 480px) {\n    .chat-widget-container {\n        width: 100px;\n        height: 1000px;\n    }\n}\n\n*/\n/*\n.rcw-input {\n  display: block;\n  height: auto; \n  line-height: 24px; \n  max-height: 150px; \n  overflow-y: auto;\n  user-select: text;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  z-index: 999999 !important;\n  &:focus-visible {\n    outline: none;\n  }\n\n  &[placeholder]:empty::before {\n    content: attr(placeholder);\n    color: $grey-0; \n  }\n}\n\n*/\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
